import { useEffect, useState } from "react";
import useSeo from "@/seo/useSeo";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";

export default function Reviews() {
  const [reviews, setReviews] = useState([]);
  const { t, tp } = useI18n();
  useSeo("/avis");

  useEffect(() => {
    api.get("/reviews").then((r) => setReviews(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="reviews-page">
      <div className="mx-auto max-w-[1400px] px-6 pt-24 sm:px-10">
        <p className="eyebrow">{t("rev.eyebrow")}</p>
        <h1 className="mt-6 max-w-3xl font-display text-5xl leading-tight tracking-wide text-bone sm:text-6xl">
          {t("rev.title")}
        </h1>

        {reviews.length ? (
          <div className="mt-16 grid gap-12 border-t border-white/10 pt-12 md:grid-cols-2" data-testid="reviews-list">
            {reviews.map((r, i) => (
              <article key={r.id} className="fade-up border-t border-white/10 pt-8" style={{ animationDelay: `${i * 70}ms` }} data-testid={`review-${i}`}>
                <span className="text-brass text-[11px]">{"★".repeat(r.rating)}</span>
                <p className="mt-6 font-display text-xl leading-relaxed text-bone/85">« {tp(r.text)} »</p>
                <footer className="mt-7 flex items-center justify-between text-[10px] uppercase tracking-[0.24em] text-bone/72">
                  <span>{r.author}{r.gite_name ? ` · ${r.gite_name}` : ""}</span>
                  <span>{r.date}</span>
                </footer>
                {r.source && r.source !== "Site" && (
                  <p className="mt-3 text-[10px] text-bone/62" data-testid={`review-source-${i}`}>
                    {t("rev.source", { s: r.source })}
                  </p>
                )}
              </article>
            ))}
          </div>
        ) : (
          <div className="mt-20 border border-white/10 bg-panel px-8 py-20 text-center" data-testid="reviews-empty">
            <p className="font-display text-3xl text-bone">{t("rev.emptyTitle")}</p>
            <p className="mx-auto mt-5 max-w-xl text-sm leading-loose text-bone/70">{t("rev.emptyText")}</p>
          </div>
        )}

        <div className="mt-24 flex flex-col items-start gap-8 border-t border-white/10 pt-16 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h2 className="font-display text-4xl tracking-wide text-bone">{t("rev.ctaTitle")}</h2>
            <p className="mt-3 text-sm text-bone/70">{t("rev.ctaText")}</p>
          </div>
          <Link to="/contact" className="btn-primary" data-testid="reviews-contact-cta">
            {t("rev.cta")} <ArrowRight size={15} />
          </Link>
        </div>
      </div>
    </div>
  );
}
